/* eslint-disable camelcase */
import lasiovi from '../images/door_models/lasiovi.svg';
import ovimalli_1l from '../images/door_models/ovimalli_1l.svg';
import ovimalli_1p from '../images/door_models/ovimalli_1p.svg';
import ovimalli_1s from '../images/door_models/ovimalli_1s.svg';
import ovimalli_3r from '../images/door_models/ovimalli_3r.svg';
import ovimalli_4v from '../images/door_models/ovimalli_4v.svg';

const cell = 1.6; // grid cell & general gutter

export default {
  cell,
  cellEm: `${cell}em`,
};

export const fonts = {
  primary: "'Dosis', sans-serif",
};

export const nonce = 'configure-eclisse';

export const shadow = process.env.REACT_APP_SHADOW
  ? `wpp_shadow=${process.env.REACT_APP_SHADOW}`
  : '';

export const colors = {
  // Grayscale
  black: '#333',
  grayDark: '#747474',
  gray: '#cfcfcf',
  grayLight: '#dcdcdc',
  grayLighter: '#ebebeb',
  whiteNear: '#f5f5f5',
  white: '#fefefe',
  // Chromatic
  orange: '#e59d01',
  red: '#ff3300',
  // Doors
  ovilehti_tammi: '#633b12',
  ovilehti_harmaa: '#9b9b9b',
  ovilehti_koivu: '#fae9b7',
  ovilehti_erikoisvari:
    'linear-gradient(to bottom, rgba(250,217,97,1) 0%, rgba(247,108,28,1) 100%)',
};
colors.ovilehti_valkoinen = colors.white;
colors.ovilehti_musta = colors.black;

export const paymentOptions = [
  'Osuuspankki',
  'Nordea',
  'Danske Bank',
  'Säästöpankki',
  'Oma Säästöpankki',
  'POP Pankki',
  'Ålandsbanken',
  'Handelsbanken',
  'S-Pankki',
  'Aktia',
  'MobilePay',
  'Visa',
  'MasterCard',
  'American Express',
  'Diners Club',
  'Collector lasku / osamaksu',
];

export const doors = {
  lasiovi,
  ovimalli_1l,
  ovimalli_1p,
  ovimalli_1s,
  ovimalli_3r,
  ovimalli_4v,
};

export const stepNames = ['kehys', 'ovilehti', 'lisävarusteet', 'määrä'];

export const configStructure = [
  {
    step: 0,
    id: 0,
    slug: 'pa_kehyksen_tyyli',
    preselect: 'listallinen',
    template: 'radio',
  },
  {
    step: 0,
    id: 1,
    slug: 'pa_karmipaketti',
    preselect: 'karmipaketti_kylla',
    template: 'radio',
    filters: [
      {
        slugs: ['listallinen'],
        terms: ['karmipaketti_kylla'],
      },
      {
        slugs: ['listaton'],
        terms: ['karmipaketti_ei'],
      },
    ],
  },
  {
    step: 0,
    id: 2,
    slug: 'pa_yksittainen_pariovi',
    preselect: 'yksittainen_ovi',
    template: 'radio',
  },
  {
    step: 0,
    id: 3,
    slug: 'pa_sahkoistys',
    preselect: 'sahkot_ei_listallinen',
    template: 'radio',
    filters: [
      {
        slugs: ['listallinen'],
        terms: ['sahkot_kylla_listallinen', 'sahkot_ei_listallinen'],
      },
      {
        slugs: ['listaton'],
        terms: ['sahkot_kylla_listaton', 'sahkot_ei_listaton'],
      },
    ],
  },
  {
    step: 0,
    id: 4,
    slug: 'pa_oviaukon_leveys',
    preselect: 'oviaukon_leveys_900_yksittainen_ovi_listallinen_sahkot_ei',
    template: 'select',
    filters: [
      {
        slugs: ['listallinen', 'yksittainen_ovi', 'sahkot_ei_listallinen'],
        terms: [
          'oviaukon_leveys_600_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_700_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_800_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_900_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1000_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1100_yksittainen_ovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1200_yksittainen_ovi_listallinen_sahkot_ei',
        ],
      },
      {
        slugs: ['listallinen', 'yksittainen_ovi', 'sahkot_kylla_listallinen'],
        terms: [
          'oviaukon_leveys_600_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_700_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_800_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_900_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1000_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1100_yksittainen_ovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1200_yksittainen_ovi_listallinen_sahkot_kylla',
        ],
      },
      {
        slugs: ['listaton', 'yksittainen_ovi', 'sahkot_ei_listaton'],
        terms: [
          'oviaukon_leveys_600_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_700_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_800_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_900_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_1000_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_1100_yksittainen_ovi_listaton_sahkot_ei',
          'oviaukon_leveys_1200_yksittainen_ovi_listaton_sahkot_ei',
        ],
      },
      {
        slugs: ['listaton', 'yksittainen_ovi', 'sahkot_kylla_listaton'],
        terms: [
          'oviaukon_leveys_600_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_700_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_800_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_900_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1000_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1100_yksittainen_ovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1200_yksittainen_ovi_listaton_sahkot_kylla',
        ],
      },
      {
        slugs: ['listallinen', 'pariovi', 'sahkot_ei_listallinen'],
        terms: [
          'oviaukon_leveys_1200_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1400_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1600_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_1800_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_2000_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_2200_pariovi_listallinen_sahkot_ei',
          'oviaukon_leveys_2400_pariovi_listallinen_sahkot_ei',
        ],
      },
      {
        slugs: ['listallinen', 'pariovi', 'sahkot_kylla_listallinen'],
        terms: [
          'oviaukon_leveys_1200_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1400_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1600_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_1800_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_2000_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_2200_pariovi_listallinen_sahkot_kylla',
          'oviaukon_leveys_2400_pariovi_listallinen_sahkot_kylla',
        ],
      },
      {
        slugs: ['listaton', 'pariovi', 'sahkot_ei_listaton'],
        terms: [
          'oviaukon_leveys_1200_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_1400_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_1600_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_1800_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_2000_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_2200_pariovi_listaton_sahkot_ei',
          'oviaukon_leveys_2400_pariovi_listaton_sahkot_ei',
        ],
      },
      {
        slugs: ['listaton', 'pariovi', 'sahkot_kylla_listaton'],
        terms: [
          'oviaukon_leveys_1200_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1400_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1600_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_1800_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_2000_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_2200_pariovi_listaton_sahkot_kylla',
          'oviaukon_leveys_2400_pariovi_listaton_sahkot_kylla',
        ],
      },
    ],
  },
  {
    step: 0,
    id: 5,
    slug: 'pa_oviaukon_korkeus',
    preselect: 'oviaukon_korkeus_2030',
    template: 'select',
    filters: [
      {
        slugs: ['listallinen'],
        terms: ['oviaukon_korkeus_2030', 'oviaukon_korkeus_2300_listallinen'],
      },
      {
        slugs: ['listaton'],
        terms: ['oviaukon_korkeus_2048', 'oviaukon_korkeus_2300_listaton'],
      },
    ],
  },
  {
    step: 1,
    id: 6,
    slug: 'pa_ovimalli',
    preselect: 'ovimalli_1s',
    template: 'radioDoor',
  },
  {
    step: 1,
    id: 7,
    slug: 'pa_pinta',
    preselect: 'ovilehti_valkoinen',
    template: 'radioColor',
    filters: [
      {
        slugs: ['lasiovi'],
        terms: ['ovilehti_valkoinen'],
      },
      {
        slugs: ['ovimalli_3r'],
        terms: [
          'ovilehti_valkoinen',
          'ovilehti_musta',
          'ovilehti_harmaa',
          'ovilehti_erikoisvari',
        ],
      },
      {
        slugs: ['ovimalli_4v'],
        terms: [
          'ovilehti_valkoinen',
          'ovilehti_musta',
          'ovilehti_harmaa',
          'ovilehti_erikoisvari',
        ],
      },
    ],
  },
  {
    step: 1,
    id: 8,
    slug: 'pa_viilun_suunta',
    preselect: 'ei_viilua',
    template: 'radio',
    filters: [
      {
        slugs: ['ovilehti_tammi'],
        terms: ['viilu_pysty', 'viilu_vaaka'],
      },
      {
        slugs: ['ovilehti_koivu'],
        terms: ['viilu_pysty', 'viilu_vaaka'],
      },
      {
        slugs: ['ovilehti_valkoinen'],
        terms: ['ei_viilua'],
      },
      {
        slugs: ['ovilehti_musta'],
        terms: ['ei_viilua'],
      },
      {
        slugs: ['ovilehti_harmaa'],
        terms: ['ei_viilua'],
      },
      {
        slugs: ['ovilehti_erikoisvari'],
        terms: ['ei_viilua'],
      },
    ],
  },
  {
    step: 1,
    id: 9,
    slug: 'pa_lasi',
    preselect: 'lasi_kirkas',
    template: 'radio',
    filters: [
      {
        slugs: ['ovimalli_1l'],
        terms: ['lasi_kirkas', 'lasi_etsattu'],
      },
      {
        slugs: ['lasiovi'],
        terms: ['lasi_kirkas', 'lasi_etsattu'],
      },
      {
        slugs: ['ovimalli_1s'],
        terms: ['ei_lasia'],
      },
      {
        slugs: ['ovimalli_1p'],
        terms: ['ei_lasia'],
      },
      {
        slugs: ['ovimalli_3r'],
        terms: ['ei_lasia'],
      },
      {
        slugs: ['ovimalli_4v'],
        terms: ['ei_lasia'],
      },
    ],
  },
  {
    step: 1,
    id: 10,
    slug: 'pa_vedin',
    preselect: 'vedin_pyorea_matta_kromi',
    template: 'radio',
    filters: [
      {
        slugs: ['pariovi'],
        terms: ['vedin_pyorea_matta_kromi', 'vedin_pyorea_kiiltava_kromi'],
      },
      {
        slugs: ['lasiovi'],
        terms: ['vedin_pyorea_matta_kromi', 'vedin_pyorea_kiiltava_kromi'],
      },
    ],
  },
  {
    step: 2,
    id: 11,
    slug: 'pa_lisavarusteet',
    preselect: 'ei_lisavarusteita',
    template: 'radio',
    filters: [
      {
        slugs: ['oviaukon_leveys_600_yksittainen_ovi_listallinen_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_700_yksittainen_ovi_listallinen_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_600_yksittainen_ovi_listallinen_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_700_yksittainen_ovi_listallinen_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_600_yksittainen_ovi_listaton_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_700_yksittainen_ovi_listaton_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_600_yksittainen_ovi_listaton_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_700_yksittainen_ovi_listaton_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['yksittainen_ovi'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_1200_pariovi_listallinen_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen', 'syncro'],
      },
      {
        slugs: ['oviaukon_leveys_1400_pariovi_listallinen_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen', 'syncro'],
      },
      {
        slugs: ['oviaukon_leveys_1200_pariovi_listallinen_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen', 'syncro'],
      },
      {
        slugs: ['oviaukon_leveys_1400_pariovi_listallinen_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen', 'syncro'],
      },
      {
        slugs: ['oviaukon_leveys_1200_pariovi_listaton_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_1400_pariovi_listaton_sahkot_ei'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_1200_pariovi_listaton_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_1400_pariovi_listaton_sahkot_kylla'],
        terms: ['ei_lisavarusteita', 'soft_close_1_suuntainen'],
      },
      {
        slugs: ['oviaukon_leveys_1600_pariovi_listaton_sahkot_ei'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_1600_pariovi_listaton_sahkot_kylla'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_1800_pariovi_listaton_sahkot_ei'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_1800_pariovi_listaton_sahkot_kylla'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_2000_pariovi_listaton_sahkot_ei'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_2000_pariovi_listaton_sahkot_kylla'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_2200_pariovi_listaton_sahkot_ei'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_2200_pariovi_listaton_sahkot_kylla'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
      {
        slugs: ['oviaukon_leveys_2400_pariovi_listaton_sahkot_kylla'],
        terms: [
          'ei_lisavarusteita',
          'soft_close_1_suuntainen',
          'soft_close_2_suuntainen',
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/assets/scripts/constants.js